export const CONSENT_KEY = 'jobifull.cookie-consent.v1';
export const BROWSER_KEY = 'jobifull.cookie-browser.v1';
export const POLICY_VERSION = 'cookies-2026-10-17';
export const CONSENT_LIFETIME = 180 * 24 * 60 * 60 * 1000;

export function validChoice(choice, now = Date.now()) {
  return Boolean(choice && choice.policy_version === POLICY_VERSION
    && typeof choice.analytics === 'boolean' && typeof choice.support === 'boolean'
    && /^[0-9a-f-]{36}$/i.test(choice.choice_id || '')
    && Number.isFinite(choice.expires_at) && choice.expires_at > now
    && choice.expires_at <= now + CONSENT_LIFETIME + 60000);
}

export function readChoice(storage, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(CONSENT_KEY));
    return validChoice(value, now) ? value : null;
  } catch { return null; }
}

export function allows(choice, category, now = Date.now()) {
  return validChoice(choice, now) && choice[category] === true && choice.receipt_id === choice.choice_id;
}

export function newChoice({ analytics = false, support = false, locale = 'en' }, uuid, now = Date.now()) {
  return { choice_id: uuid, policy_version: POLICY_VERSION, analytics: analytics === true,
    support: support === true, locale: ['pt', 'es', 'en'].includes(locale) ? locale : 'en',
    expires_at: now + CONSENT_LIFETIME, receipt_id: null };
}
